import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import PropTypes from 'prop-types';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Button } from '@uhg-abyss/web/ui/Button';
import { event } from '@uhg-abyss/web/tools/event';
import { useCopy } from '@uhg-abyss/web/hooks/useCopy';

const Wrapper = styled('div', {});

const IdBox = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingTop: '3px',
  paddingBottom: '3px',
  paddingLeft: '10px',
  background: '#ffffff',
  border: '1px solid #000000',
  boxSizing: 'border-box',
  borderRadius: '4px',

  p: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '15px',
    lineHeight: '24px',
    textAlign: 'center',
    color: '#333333',
    marginBottom: 0,
  },
});

const ButtonContainer = styled('div', {
  display: 'flex',
  gap: '0px',
  alignItems: 'center',
});

export const DisplayField = ({
  label,
  value,
  environment,
  isShowCopy,
  keyId,
  setShowDeleteModal,
  isNewlyCreated,
  isSecretKeeper,
}) => {
  const { onCopy } = useCopy(value);
  const copyEvent = () => {
    const interactionName = 'credentials';
    const interactionValue = `${environment} ${label}`;
    const interactionContext = 'copy code';
    event('INTERACTION_EVENT', {
      interactionName,
      interactionValue,
      interactionContext,
    });
  };

  const renderButtons = () => {
    const commonButtonProps = {
      size: '$sm',
      variant: 'outline',
      css: {
        'abyss-button-root': {
          border: 'none',
          paddingLeft: '6px',
          paddingRight: '6px',
        },
      },
    };

    const copyButton = (
      <Button
        {...commonButtonProps}
        id={`${label}-${value}-copy`}
        onClick={() => {
          onCopy();
          copyEvent();
        }}
      >
        <IconSymbol icon="content_copy" color="$primary1" variant="outlined" />
      </Button>
    );

    const deleteButton = isSecretKeeper && (
      <Button
        {...commonButtonProps}
        id={`${label}-${value}-delete`}
        onClick={() => {
          setShowDeleteModal(keyId, environment);
        }}
      >
        <IconSymbol icon="delete" color="$primary1" variant="outlined" />
      </Button>
    );

    // Show copy button for Client Id or when explicitly set to show copy
    if (isShowCopy || label === 'Client Id') {
      return copyButton;
    }

    // For newly created secrets, show both copy and delete buttons
    if (isNewlyCreated) {
      return (
        <ButtonContainer>
          {copyButton}
          {deleteButton}
        </ButtonContainer>
      );
    }

    // Default case: show only delete button if user is secret keeper
    return deleteButton;
  };

  return (
    <Wrapper>
      <p id={`${label}`} className="label">
        {label}
      </p>
      <IdBox>
        <p id={`${value}`}>{value}</p>
        {renderButtons()}
      </IdBox>
    </Wrapper>
  );
};

DisplayField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  environment: PropTypes.string.isRequired,
  isShowCopy: PropTypes.bool,
  keyId: PropTypes.string,
  setShowDeleteModal: PropTypes.func,
  isNewlyCreated: PropTypes.bool,
  isSecretKeeper: PropTypes.bool,
};
